import React, { Suspense, useContext } from 'react';
import proptypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Skeleton, SkeletonLine } from '@one-thd/sui-atomic-components';
import { ToasterProvider } from './Toaster/ToasterProvider';
import {
  AREA,
  INSTALLED_CARPET_SEGMENT,
  FIXED_WIDTH
} from '../../../constants';

const { arrayOf, node, oneOfType, string, shape } = proptypes;

const CalculatorProvider = React.lazy(() => import(
  /* webpackChunkName: "calculator-flooringdrawer" */'../CalculatorProvider'
));

const CalculatorPlaceholder = () => {
  return (
    <Skeleton
      PaperProps={{
        variant: 'shadow',
        className: 'sui-grow'
      }}
      grow
    >
      <SkeletonLine fullWidth variant="multi" numberOfLines={2} />
    </Skeleton>
  );
};

export const FlooringCalculatorWrapper = ({ taxonomy, children }) => {
  const { segment } = useContext(ExperienceContext);
  const calculatorType = segment === INSTALLED_CARPET_SEGMENT ? FIXED_WIDTH : AREA;

  return (
    <div data-component="FlooringCalculatorWrapper" className="sui-flex sui-grow">
      {typeof window === 'undefined' ? <CalculatorPlaceholder /> : (
        <ToasterProvider>
          <Suspense fallback={<CalculatorPlaceholder />}>
            <CalculatorProvider
              calculatorType={calculatorType}
              taxonomy={taxonomy}
              lineItemName="Area"
              isFlooringDrawer
            >
              {children}
            </CalculatorProvider>
          </Suspense>
        </ToasterProvider>
      )}
    </div>
  );
};

FlooringCalculatorWrapper.displayName = 'FlooringCalculatorWrapper';

FlooringCalculatorWrapper.propTypes = {
  children: oneOfType([
    arrayOf(node),
    node
  ]).isRequired,
  taxonomy: shape({
    breadCrumbs: arrayOf(shape({
      label: string
    }))
  }).isRequired,
};
